import React, { useEffect, useState } from "react";
import { Dropdown, Alert, Spinner } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { getTimings, createTimings, updateTimings, deleteTimings } from "../../../../APIS";
import { emojis } from "../../bootstrap/alertData";

const Timings = ({serviceId=1}) => {

  const [timings, setTimings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({ time_from: "", time_to: "", routeId: serviceId });

  // Alerts
  const [successMsg, setSuccessMsg] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);

  // ✅ Fetch Timings
  const fetchTimings = async () => {
    setLoading(true);
    try {
      const res = await getTimings(serviceId);
      setTimings(res.data.timings || []);
    } catch (error) {
      setErrorMsg("Failed to fetch timings ❌");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (serviceId) fetchTimings();
  }, [serviceId]);

  // ✅ Handle Form Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Submit Form
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditMode) {
        await updateTimings(formData.id, formData);
        setSuccessMsg("Timing updated ✅");
      } else {
        await createTimings(formData);
        setSuccessMsg("Timing added ✅");
      }
      setShowForm(false);
      setIsEditMode(false);
      fetchTimings();
    } catch (error) {
      setErrorMsg("Error saving timing ❌");
    }
  };

  // ✅ Delete Timing
  const handleDelete = async (id) => {
    try {
      await deleteTimings(id);
      setSuccessMsg("Timing deleted ✅");
      fetchTimings();
    } catch (error) {
      setErrorMsg("Error deleting timing ❌");
    }
  };

  return (
    <div className="col-12">
      {/* Alerts */}
      {successMsg && <Alert variant="success" onClose={() => setSuccessMsg(null)} dismissible>{emojis.success} {successMsg}</Alert>}
      {errorMsg && <Alert variant="danger" onClose={() => setErrorMsg(null)} dismissible>{emojis.warning} {errorMsg}</Alert>}

      <div className="card">
        {!showForm ? (
          <>
            <div className="card-header d-flex justify-content-between align-items-center">
              <h4 className="card-title m-0">Route Timings</h4>
              <button
                className="btn btn-secondary btn-md"
                onClick={() => {
                  setFormData({ time_from: "", time_to: "", routeId: serviceId });
                  setIsEditMode(false);
                  setShowForm(true);
                }}
              >
                Add Timing
              </button>
            </div>

            <div className="card-body">
              {loading ? (
                <div className="d-flex justify-content-center p-4"><Spinner animation="border" /></div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Time From</th>
                        <th>Time To</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {timings.length > 0 ? timings.map((t, i) => (
                        <tr key={t.id}>
                          <td>{i + 1}</td>
                          <td>{t.time_from}</td>
                          <td>{t.time_to}</td>
                          <td>
                            <Dropdown>
                              <Dropdown.Toggle variant="link">&#x2022;&#x2022;&#x2022;</Dropdown.Toggle>
                              <Dropdown.Menu align="end">
                                <Dropdown.Item onClick={() => { setFormData(t); setIsEditMode(true); setShowForm(true); }}>Edit</Dropdown.Item>
                                <Dropdown.Item onClick={() => handleDelete(t.id)}>Delete</Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                        </tr>
                      )) : (
                        <tr><td colSpan="4" className="text-center">No timings found.</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3 row">
                <label className="col-lg-2 col-form-label">Time From</label>
                <div className="col-lg-4">
                  <input
                    type="text"
                    name="time_from"
                    value={formData.time_from}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="e.g. 10:00 AM"
                    required
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <label className="col-lg-2 col-form-label">Time To</label>
                <div className="col-lg-4">
                  <input
                    type="text"
                    name="time_to"
                    value={formData.time_to}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="e.g. 07:00 PM"
                    required
                  />
                </div>
              </div>
              <div className="mt-3">
                <button type="submit" className="btn btn-secondary">Save</button>
                <button type="button" className="btn btn-primary ms-2" onClick={() => setShowForm(false)}>Cancel</button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default Timings;